<template>
  <div class="product">
    <div class="product-banner">
      <ul class="product-nav">
        <li
          v-for="(item,index) in navList"
          :key="index"
          @click="showItem(index)"
          @mouseenter="handShowItem(index)"
          @mouseleave="handHideItem(index)"
          :class="{'nav-active' : activeIndex == index || item.showItems}"
        >
          {{item.name}}
          <transition name="fade" enter-active-class="animated fadeIn" class="animated fadeOut">
            <div v-if="item.showItems" class="product-menu">
              <p
                v-for="(obj,i) in item.items"
                :key="i"
                :class="{'active' : targetIndex == i}"
                @click="changeActive(index,i)"
              >{{obj.name}}</p>
            </div>
          </transition>
        </li>
      </ul>
      <div >
        <p>{{productList[activeIndex][0].name}}</p>
        <p>{{productList[activeIndex][0].content}}</p>
      </div>
    </div>
      <div id="banner" style="position:relative;top:-100px"></div>
    <div v-for="(item,index) in productList[activeIndex]" :key="index" :ref="'product'+index">
      <template v-if="index > 0">
        <div class="product-content-top" v-if="index % 2 == 1" :id="'product' + (index-1)">
          <div class="text-left">
            <div class="title">{{item.name}}</div>
            <p class="title-content" v-for="(obj,i) in item.content" :key="i">
              {{obj}}
            </p>
            <!-- <div class="product-content-icons">
              <img :src="obj.img" alt />
              <p>
                钉钉
                <span>+</span>蓝凌
              </p>
            </div> -->
          </div>
          <div class="img-right">
            <img :src="item.img" alt />
          </div>
        </div>
        <div class="product-content-bottom" v-else :id="'product' + (index-1)">
          <div class="img-left">
            <img :src="item.img" alt />
          </div>
          <div class="text-right">
            <div class="title">{{item.name}}</div>
            <p class="title-content" v-for="(obj,i) in item.content" :key="i">{{obj}}</p>
            <!-- <div class="product-content-icons">
              <img src="../assets/light/01.png" alt />
              <p>
                钉钉
                <span>+</span>蓝凌
              </p>
            </div> -->
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { productList } from "../datas.js";
export default {
  data() {
    return {
      navList: [
        {
          name: "日常办公",
          items: [
            {
              name: "审批流程",
              isActive: false
            },
            {
              name: "工作总结",
              isActive: false
            },
            {
              name: "考勤打卡",
              isActive: false
            },
            {
              name: "规范制度",
              isActive: false
            }
          ],
          showItems: false
        },
        {
          name: "团队协作",
          items: [
            {
              name: "知识中心",
              isActive: false
            },
            {
              name: "日程安排",
              isActive: false
            },
            {
              name: "任务管理",
              isActive: false
            },
            {
              name: "项目工作室",
              isActive: false
            }
          ],
          showItems: false
        },
        {
          name: "客户在线",
          items: [
            {
              name: "客户档案",
              isActive: false
            },
            {
              name: "商机跟踪",
              isActive: false
            },
            {
              name: "合同管理",
              isActive: false
            },
            {
              name: "收款跟踪",
              isActive: false
            },
            {
              name: "销售报表",
              isActive: false
            }, 
          ],
          showItems: false
        },
        {
          name: "人事在线",
          items: [
            {
              name: "人事档案",
              isActive: false
            },
            {
              name: "人员招聘",
              isActive: false
            },
            {
              name: "人事流程",
              isActive: false
            },
            {
              name: "人事报表",
              isActive: false
            }
          ],
          showItems: false
        },
        {
          name: "行政管理",
          items: [
            {
              name: "固资管理",
              isActive: false
            },
            {
              name: "办公资源管理",
              isActive: false
            },
            {
              name: "办公用品管理",
              isActive: false
            },
            {
              name: "车辆管理",
              isActive: false
            },
            {
              name: "档案管理",
              isActive: false
            },
            {
              name: "图书管理",
              isActive: false
            },
            {
              name: "证照管理",
              isActive: false
            }
          ],
          showItems: false
        },
        {
          name: "企业文化",
          items: [
            {
              name: "网上调查",
              isActive: false
            },
            {
              name: "员工黄页",
              isActive: false
            },
            {
              name: "员工活动",
              isActive: false
            },
            {
              name: "内部社区",
              isActive: false
            },
            {
              name: "投票管理",
              isActive: false
            },
            {
              name: "信息公告",
              isActive: false
            }
          ],
          showItems: false
        },
        {
          name: "扩展模块",
          items: [
            {
              name: "公文管理",
              isActive: false
            },
            {
              name: "考试管理",
              isActive: false
            },
            {
              name: "ERP财务集成",
              isActive: false
            }
          ],
          showItems: false
        },
        {
          name: "个性化钉钉",
          items: [
            {
              name: "自定义工作台",
              isActive: false
            },
            {
              name: "专属考勤开放",
              isActive: false
            },
            {
              name: "专属日程开放",
              isActive: false
            },
            {
              name: "消息通知配置",
              isActive: false
            },
            {
              name: "私有定制",
              isActive: false
            }
          ],
          showItems: false
        }
      ],
      hideNavBar: null,
      productList: productList,
      activeIndex: 0,
      targetIndex : 0,
    };
  },
  created() {
    if(this.$route.query.title) {
      this.checkIndex()
    }
  },
  mounted() {
    window.addEventListener("scroll", this.appScroll);
  },
  methods: {
    appScroll() {
      this.hideNavBar = document.documentElement.scrollTop > 100 ? true : false;
    },
    showItem(index) {
      this.activeIndex = index;
      document.body.scrollTop = 0;
      switch (index) {
        case 0:
          _czc.push(["_trackEvent", "顶部功能菜单_日常办公", "menu", ""]);
          break;
        case 1:
          _czc.push(["_trackEvent", "顶部功能菜单_团队协作", "menu", ""]);
          break;
        case 2:
          _czc.push(["_trackEvent", "顶部功能菜单_客户在线", "menu", ""]);
          break;
        case 3:
          _czc.push(["_trackEvent", "顶部功能菜单_人事在线", "menu", ""]);
          break;
        case 4:
          _czc.push(["_trackEvent", "顶部功能菜单_行政管理", "menu", ""]);
          break;
        case 5:
          _czc.push(["_trackEvent", "顶部功能菜单_企业文化", "menu", ""]);
          break;
        case 6:
          _czc.push(["_trackEvent", "顶部功能菜单_拓展模块", "menu", ""]);
          break;
        case 7:
          _czc.push(["_trackEvent", "顶部功能菜单_个性化钉钉", "menu", ""]);
          break;
      }
      console.log(_czc);
    },
    handShowItem(index) {
      this.targetIndex = null
      this.navList.forEach((item, i) => {
        item.showItems = index == i ? true : false;
      });

    },
    handHideItem(index, i) {
      this.$set(this.navList[index], "showItems", false);
    },
    changeActive(index, i) {
      this.targetIndex = i 
      setTimeout(() => {
        this.getTarget()  
      }, 0);

    },
    getTarget() {
      let targetIndex = this.targetIndex
      document.body.scrollTop = document.querySelector('#product'+targetIndex).offsetTop - document.querySelector('#product'+targetIndex).offsetHeight/2
      document.documentElement.scrollTop = document.querySelector('#product'+targetIndex).offsetTop - document.querySelector('#product'+targetIndex).offsetHeight/2
    },
    checkIndex() {
        let title = this.$route.query.title;
        switch (title) {
            case '日常办公' : 
              this.activeIndex = 0
            break;
            case '团队协作' :
              this.activeIndex = 1
            break; 
            case '客户在线' :
              this.activeIndex = 2;
            break;
            case '人事在线' :
              this.activeIndex = 3 ;
            break;
            case '行政管理' : 
              this.activeIndex = 4;
            break;
            case '企业文化' :
              this.activeIndex = 5;
            break;
        }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.appScroll);
  }
};
</script>

<style lang="less" scoped>
.product {
  min-width: 1200px;
  .product-nav {
    background: #4285f4;
    margin: 0 auto;
    font-size: 14px;
    color: #CCDFFF;
    text-align: center;
    height: 60px;
    line-height: 60px;
    position: fixed;
    top: 70px;
    width: 100%;
    min-width: 1200px;
    z-index: 10;
    li {
      padding: 0 25px;
      display: inline-block;
      cursor: pointer;
      position: relative;
      div {
        position: absolute;
        top: 60px;
        left: 0;
        right: 0;
        z-index: 10;
        background: white;
        padding: 0 25px;
        box-shadow: 0 1px 6px 0 rgba(33, 117, 207, 0.4);
        border-radius: 6px;
        color: #333333;
        padding: 10px 0;
        width:124px;
        text-align:center;
        p {
          line-height: 32px;
        }
      }
    }
    .nav-active{
      color: white;
      font-weight: normal;
    }
    .active {
      color: #4285f4;
      background: #f2f8ff;
    }
  }
  .product-banner {
    margin-top: 70px;
    height: 380px;
    background: url("../assets/help_bg.png") 0 0 no-repeat;
    background-size: 100% 100%;
    margin-bottom: 30px;
    color: white;
    display: flex;
    align-items: center;
    > div {
      width: 1200px;
      margin: 0 auto;
      text-align: center;
      p {
        font-size: 20px;
        text-align: center;
        margin: 0 auto;
        line-height: 30px;

        &:nth-child(1) {
          font-size: 42px;
          text-align: center;
          margin-bottom: 40px;
          line-height: 1;
        }
        &:nth-last-child(2) {
        }
      }
    }
  }
  .product-content-top {
    width: 1200px;
    margin: 0 auto;
    padding-left: 80px;
    padding-right: 106px;
    padding-bottom: 40px;
    display: flex;
    .title {
      margin-bottom: 13px;
      font-size: 28px;
      color: #333333;
    }
    .product-content-icons {
      display: flex;
      margin-top: 33px;
      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .text-left {
      padding-left: 70px;
      width: 460px;
      text-align: justify;
      display: flex;
      flex-direction: column;
      justify-content: center;
      p {
        font-size: 16px;
        color: #666666;
        text-align: justify;
      }
      .title-content {
        padding-bottom: 30px;
        line-height:22px;
      }
    }
    .img-right {
      padding-left: 173px;
      img {
        width: 460px;
      }
    }
  }
  .product-content-bottom {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 40px;
    padding-left: 80px;
    padding-right: 106px;
    display: flex;
    .title {
      margin-bottom: 13px;
      font-size: 28px;
      color: #333333;
    }
    .product-content-icons {
      display: flex;
      margin-top: 33px;
      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .text-right {
      padding-left: 143px;
      width: 487px;
      text-align: justify;
      display: flex;
      flex-direction: column;
      justify-content: center;;
      p {
        font-size: 16px;
        color: #666666;
        text-align: justify;
      }
      .title-content {
        padding-bottom: 30px;
        line-height:22px;
      }
    }
    .img-left {
      img {
        width: 487px;
      }
    }
  }
}
.nav-aimatetop {
  animation: scrolltop 0.1s forwards;
}
@keyframes scrolltop {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-60px);
  }
}
.nav-aimatebottom {
  animation: scrollbottom 0.1s forwards;
}
@keyframes scrollbottom {
  0% {
    transform: translateY(-60px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/product.vue